// Shared by the backend and the frontend, so keep it free of node-only imports.

const EVM_ADDRESS = /^(0x)?[0-9a-fA-F]{40}$/

// Bitquery labels keep EVM addresses lowercase with 0x; flows store them
// without 0x and the transactions table shows them with it. Other chains'
// addresses (Tron base58, Bitcoin) are case-sensitive and kept as they are.
export const toLabelAddress = (address: string) => {
    const trimmed = address.trim()
    return EVM_ADDRESS.test(trimmed) ? "0x" + trimmed.replace(/^0x/, "").toLowerCase() : trimmed
}
